import { useEffect, useState } from "react";
import { BookOpen, MapPin, ChevronDown } from "lucide-react";
import api from "../../lib/api";

function Col({ title, items, onOpen, testid }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="min-w-0" data-testid={testid}>
      <button type="button" onClick={() => setOpen((o) => !o)} aria-expanded={open} className="w-full flex items-center justify-between gap-2 rounded-lg border border-slate-200 px-3 py-2 text-left hover:bg-slate-50" data-testid={`${testid}-toggle`}>
        <span className="text-sm font-semibold text-slate-800 flex items-center gap-1.5"><MapPin className="w-3.5 h-3.5 text-primary" /> {title} <span className="text-slate-400 font-normal">· {items.length}</span></span>
        <ChevronDown className={`w-4 h-4 text-slate-400 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && <ul className="mt-1 max-h-64 overflow-y-auto pr-1">
        {items.map((d) => (
          <li key={d.id}>
            <button type="button" onClick={() => onOpen(d.id)} className="w-full text-left px-2 py-1.5 rounded-md hover:bg-slate-50 flex items-center gap-2" data-testid={`researched-dept-${d.id}`}>
              <span className="text-sm text-slate-800 truncate flex-1" title={`${d.name} — ${d.city}, ${d.state}`}>{d.name}{d.state !== "CA" && <span className="text-slate-400 text-xs"> · {d.state}</span>}</span>
              {d.researching && <span className="text-[10px] text-amber-600 shrink-0">researching…</span>}
              {d.owned && <span className="text-[10px] font-bold uppercase text-emerald-700 shrink-0">Yours</span>}
            </button>
          </li>
        ))}
        {!items.length && <li className="px-2 py-1.5 text-xs text-slate-400">None yet.</li>}
      </ul>}
    </div>
  );
}

// Premium: every researched profile in the shared bank — all of it is open to you. Derived live from department status.
export function ResearchedList({ onOpen, refreshKey, actions = null }) {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/departments/researched").then(({ data }) => setData(data)).catch(() => {}); }, [refreshKey]);
  if (!data) return null;
  return (
    <section className="rounded-xl border border-slate-200 bg-white px-4 py-3 sm:px-5 sm:py-4" data-testid="researched-list">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div>
          <p className="text-sm font-semibold text-slate-800 inline-flex items-center gap-1.5"><BookOpen className="w-4 h-4 text-primary" /> Browse Researched Departments <span className="font-heading text-lg font-bold text-slate-900" data-testid="researched-count">{data.total}</span></p>
          <p className="text-xs text-slate-500 mt-0.5">Every researched profile in the library is open to you as a Premium member.</p>
        </div>
        {actions}
      </div>
      <div className="mt-2 grid grid-cols-1 sm:grid-cols-2 gap-4">
        <Col title="California" items={data.california} onOpen={onOpen} testid="researched-california" />
        <Col title="Nationwide" items={data.other} onOpen={onOpen} testid="researched-other" />
      </div>
    </section>
  );
}
